import { DocumentTaxonomyConfig } from 'entities/tag';

export interface MissingDefaults {
  lei: boolean;
  date: boolean;
  currency: boolean;
  scale: boolean;
  accuracy: boolean;
}

export const getMissingDefaults = (config: DocumentTaxonomyConfig | null | undefined): MissingDefaults => ({
  lei: !config?.entity,
  date: !config?.contextSelections?.some((c) => c.isActive),
  currency: !config?.currencySelections?.some((c) => c.isActive),
  scale: config?.scale == null,
  accuracy: config?.decimals == null && config?.precision == null,
});

export const hasMissingDefaults = (missing: MissingDefaults): boolean => Object.values(missing).some(Boolean);
